import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { useTaskCounters } from '@/src/components/project/Dashboard/api/getTaskCounters';
import { RootState } from '@/src/reducers/types';

import { Columns } from './Config';

const STATUS_COLUMNNS = {
  today: ['status', 'assignee'],
  forReview: ['status', 'reviewer', 'dueDate'],
  forApproval: ['status', 'approver', 'dueDate'],
  delayed: ['assignee', 'dueDate'],
};

const getOptionalParams = ({ type, loggedUser, today }) => {
  let status = '';
  let dueDate = null;
  let userType = null;
  let userId = null;

  if (loggedUser.data.userRole > 3 && loggedUser.data.userRole !== 5) {
    userId = loggedUser.data.id;

    if (type === 'forApproval') {
      userType = 'forApproval';
    } else {
      userType = 'assignedToMe';
    }
  }

  switch (type) {
    case 'today':
      status = JSON.stringify({ opt: 'not', value: 'Completed' });
      dueDate = JSON.stringify({ opt: 'eq', value: today });

      break;
    case 'forReview':
      status = JSON.stringify({ opt: 'eq', value: ['For Review', 'Change Requested'] });

      break;
    case 'forApproval':
      status = JSON.stringify({ opt: 'eq', value: ['For Approval', 'Change Requested'] });
      break;
    case 'delayed':
      dueDate = JSON.stringify({ opt: 'lt', value: today });
      status = JSON.stringify({ opt: 'eq', value: ['For Approval', 'Change Requested'] });

      break;
  }

  return { status, dueDate, userId, type: userType };
};

const TaskList = ({ type }) => {
  const { projectId } = useParams<{ projectId: string }>();
  const loggedUser = useSelector((store: RootState) => store.loggedUser);
  const [today] = useState(moment().format('YYYY-MM-DD'));
  const counterListQuery = useTaskCounters({
    projectId,
    page: 1,
    limit: 5,
    ...getOptionalParams({ type, loggedUser, today }),
  });
  const itemListColumns = STATUS_COLUMNNS[type];

  return (
    <div className="taskListContainer">
      <table>
        <thead>
          <tr>
            <th>Task Name</th>
            {itemListColumns.map((columnKey) => {
              return <th key={`counterListHeaderKey_${columnKey}`}>{Columns[columnKey].label}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {counterListQuery.data && counterListQuery.data.result.length > 0 && (
            <React.Fragment>
              {counterListQuery.data &&
                counterListQuery.data.result.map((item) => {
                  return (
                    <tr key={`counterListBodyRowKey_${item.id}`}>
                      <td className="taskNameColumn">
                        <div className="taskName">
                          {item.periodType && (
                            <span>
                              <i className="material-icons mr5 ml0">cached</i>
                            </span>
                          )}
                          <a
                            href={`/account#/projects/${item.task_project.id}/processes/tasks?action=view&taskid=${item.id}`}
                          >
                            <span>{item.task}</span>
                          </a>
                        </div>
                      </td>
                      {itemListColumns.map((columnKey) => {
                        return (
                          <td key={`counterListBodyDateKey_${columnKey}`}>
                            {Columns[columnKey].Component(item)}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            </React.Fragment>
          )}
          {counterListQuery.data && counterListQuery.data.result.length === 0 && (
            <tr>
              <td colSpan={itemListColumns.length + 1}>No records found</td>
            </tr>
          )}
          {!counterListQuery.data && counterListQuery.isLoading && (
            <tr>
              <td colSpan={itemListColumns.length + 1}>Loading...</td>
            </tr>
          )}
          {counterListQuery.data && counterListQuery.data.result.length >= 5 && (
            <tr>
              <td colSpan={itemListColumns.length + 1} className="notice-td">
                <div className="clickNotice">
                  <i className="material-icons">info</i>
                  <span> Click the counter to view more</span>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TaskList;
